export default "__VITE_ASSET__BUjR8MhZ__"